module.exports = __webpack_public_path__ + "static/media/notfound.98b2a79f.png";